// reducer.js
import * as types from "../../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status:false
};

const fetchCountriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_COUNTRIES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_COUNTRIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        status: action.payload.status,
      };
    case types.FETCH_COUNTRIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: [],
        message: action.payload.message,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

export default fetchCountriesReducer;
